"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var Radio = function Radio(props) {
  var _clsx;
  var _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    name = props.name,
    label = props.label,
    value = props.value,
    onChange = props.onChange,
    className = props.className,
    _props$isButtonRight = props.isButtonRight,
    isButtonRight = _props$isButtonRight === void 0 ? false : _props$isButtonRight,
    _onClick = props.onClick;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('radio'), className, (_clsx = {}, (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('radio__checked'), checked), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('radio__disabled'), disabled), _clsx))
  }, isButtonRight && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('radio-label'), (0, _getPrefixCls.getPrefixCls)('radio-label-left'))
  }, label), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _getPrefixCls.getPrefixCls)('radio-circle')
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    disabled: disabled,
    value: value,
    checked: checked,
    name: name,
    onChange: onChange,
    onClick: function onClick(event) {
      console.log('click', event, event.currentTarget.value, event.target);
      var selectedValue = event.currentTarget.value; // 在这里使用 selectedValue 来进行操作

      _onClick === null || _onClick === void 0 ? void 0 : _onClick(selectedValue);
    },
    className: (0, _getPrefixCls.getPrefixCls)('radio-input')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _getPrefixCls.getPrefixCls)('radio-circle-inner')
  })), !isButtonRight && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _getPrefixCls.getPrefixCls)('radio-label')
  }, label));
};
exports.Radio = Radio;